import api from './BaseService'


async function podeResponderFormulario(codigoCliente,formularioId, pessoaId){
    const url = `clientes/${codigoCliente}/pessoa/${pessoaId}/formulario/${formularioId}/podeResponder`;
    let result = null;
    const {statusText,data} = await api.get(url);
    if(statusText == "OK"){
        result = data;
    }

    
    return result;
}
async function obterFormulariosDisponiveis(codigoCliente, pessoaId){
    let result = [];
    const {statusText,data} = await api.get(`clientes/${codigoCliente}/formulariosDisponiveis/pessoa/${pessoaId}`);
    if(statusText == "OK"){
        result = [...data];
    }
    return result;
}

async function obterClientePorApelido(apelidoCliente){
    try{
        const result = await api.get(`clientes/${apelidoCliente}`);       
        return result.data;
        
    }catch(error){
        console.error('erro na requisicação', result);
    }
}

const clienteService ={
    obterClientePorApelido,
    obterFormulariosDisponiveis,
    podeResponderFormulario
}

export default clienteService;


// WEBPACK FOOTER //
// ./src/services/ClienteService.js